import { render, staticRenderFns } from "./ProductReview.vue?vue&type=template&id=4ebba59f&scoped=true"
import script from "./ProductReview.vue?vue&type=script&lang=js"
export * from "./ProductReview.vue?vue&type=script&lang=js"
import style0 from "./ProductReview.vue?vue&type=style&index=0&id=4ebba59f&prod&scoped=true&lang=css"
import style1 from "./ProductReview.vue?vue&type=style&index=1&id=4ebba59f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebba59f",
  null
  
)

export default component.exports